import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectQueryString } from 'workspaces/react-router-selectors';
import { selectErrors } from 'services/error/selectors';

// Types
import { RequestHeaders } from 'services/error/types';
import { QueryStringSelectorResult } from './types';

export const makeSelectQueryStringErrorMessage = (
    field: string
): QueryStringSelectorResult =>
    createDeepEqualSelector(
        [selectErrors, selectQueryString],
        (errorsState, queryStringState): string | undefined => {
            const namespaceToUse = queryStringState[field] as
                | string
                | string[]
                | undefined;

            if (!namespaceToUse) {
                return undefined;
            }

            // Return the messages for multiple errors
            if (Array.isArray(namespaceToUse)) {
                const message = namespaceToUse
                    .map((value: string): string | undefined =>
                        get(errorsState, [value, 'message'])
                    )
                    .filter((value: string | undefined): boolean => !!value)
                    .join(', ');

                return message || undefined;
            }

            // Return the message for a single error
            return get(errorsState, [namespaceToUse, 'message']);
        }
    );

export const makeSelectQueryStringErrorHeaderValue = (
    field: string,
    header: keyof RequestHeaders
): QueryStringSelectorResult =>
    createDeepEqualSelector(
        [selectErrors, selectQueryString],
        (errorsState, queryStringState): string | undefined => {
            const namespaceToUse = queryStringState[field] as
                | string
                | undefined;

            if (!namespaceToUse) {
                return undefined;
            }

            // Return the requestId based on the query string value
            return get(errorsState, [namespaceToUse, 'headers', header]);
        }
    );
